/* src/app/umbrella-common/components/sales-force-card/sales-force-card.style.scss */
.send-opportunity-id-btn {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 20px;
}
.send-opportunity-id-btn button {
  height: 32px;
  padding: 0 18px;
}
.button-section {
  display: flex;
}
#send-button {
  margin-left: 11px;
}
.label-flex {
  display: flex;
  justify-content: space-between;
}
.label {
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
  margin-bottom: 8px;
}
.data-compare-div {
  margin-top: 20px;
}
.note {
  font-family: Arial, sans-serif;
  font-size: 15px;
  line-height: 1.33;
  color: #585858;
}
/*# sourceMappingURL=sales-force-card.style.css.map */
